import { useEffect, useRef, useState } from 'react';

export const DEFAULT_MIN_LOADER_MS = 450;

/**
 * Keeps a loading UI visible for at least minDurationMs.
 */
export default function useMinimumLoader(isLoading, minDurationMs = DEFAULT_MIN_LOADER_MS) {
  const [showLoading, setShowLoading] = useState(Boolean(isLoading));
  const startTimeRef = useRef(Date.now());

  useEffect(() => {
    let timeoutId;

    if (isLoading) {
      startTimeRef.current = Date.now();
      setShowLoading(true);
      return undefined;
    }

    const elapsed = Date.now() - startTimeRef.current;
    const remaining = Math.max(minDurationMs - elapsed, 0);

    timeoutId = setTimeout(() => {
      setShowLoading(false);
    }, remaining);

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isLoading, minDurationMs]);

  return showLoading;
}
